// Auto-applies/removes the accessory discount code as cases enter/leave the cart. Config from #cm-auto-discount-config.
(function () {
  'use strict';

  // Pure: full code list to send via /cart/update.js, or null when the cart already matches the desired state.
  function desiredCodes(currentCodes, hasCase, ourCode) {
    var ourLower = ourCode.toLowerCase();
    var hasOurs = currentCodes.some(function (c) { return c.toLowerCase() === ourLower; });
    if (hasCase && !hasOurs) return currentCodes.concat([ourCode]);
    if (!hasCase && hasOurs) return currentCodes.filter(function (c) { return c.toLowerCase() !== ourLower; });
    return null;
  }

  // Pure: de-duped codes (case-insensitive, first spelling wins) from every place Shopify can surface a code discount.
  function currentCodesFromCart(cart) {
    if (!cart || typeof cart !== 'object') return [];
    var seenLower = [];
    var out = [];
    function add(code) {
      if (!code) return;
      var lower = code.toLowerCase();
      if (seenLower.indexOf(lower) !== -1) return;
      seenLower.push(lower);
      out.push(code);
    }
    // fast path: present on carts fetched after the May 2025 discount-in-cart rollout
    (Array.isArray(cart.discount_codes) ? cart.discount_codes : []).forEach(function (d) {
      if (d) add(d.code);
    });
    // fallback: code discounts also show up as applications titled with the code itself; automatic ones are not ours
    function addFromApplication(app) {
      if (app && app.type === 'discount_code') add(app.title);
    }
    (cart.cart_level_discount_applications || []).forEach(addFromApplication);
    (cart.items || []).forEach(function (item) {
      (item && item.line_level_discount_allocations || []).forEach(function (alloc) {
        if (alloc) addFromApplication(alloc.discount_application);
      });
    });
    return out;
  }

  var exported = { desiredCodes: desiredCodes, currentCodesFromCart: currentCodesFromCart };
  if (typeof window !== 'undefined') window.CMAutoDiscount = exported;
  if (typeof module !== 'undefined' && module.exports) module.exports = exported;

  // Below this line is browser runtime only; Node's test runner never reaches it (no `document`).
  if (typeof document === 'undefined') return;

  var configEl = document.getElementById('cm-auto-discount-config');
  if (!configEl) return;
  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }
  if (!config || !config.code || !config.triggerTypes || !config.triggerTypes.length) return;

  // trimmed here so the settings_schema textarea tolerates "a, b" as well as "a,b"
  var triggerTypes = config.triggerTypes.map(function (t) { return t.trim(); });

  var inFlight = false;
  var warnedNotApplicable = false;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function run() {
    if (inFlight) return;
    inFlight = true;
    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var currentCodes = currentCodesFromCart(cart);
        var hasCase = (cart.items || []).some(function (item) {
          return triggerTypes.indexOf(item.product_type) !== -1;
        });

        // applicable is only known when the fast-path field exists; without it we can't detect the "present but rejected" case
        var ourLower = config.code.toLowerCase();
        var discountEntries = Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
        var ours = discountEntries.filter(function (d) { return d && d.code && d.code.toLowerCase() === ourLower; })[0];
        if (hasCase && ours && ours.applicable === false) {
          if (!warnedNotApplicable) {
            console.warn('[cm-auto-discount] code present but not applicable, leaving it as-is', ours);
            warnedNotApplicable = true;
          }
          return null;
        }

        var next = desiredCodes(currentCodes, hasCase, config.code);
        if (next === null) return null;

        return fetch(root() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: next.join(',') }),
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            warnedNotApplicable = false;
            // source lets our own DOMContentLoaded/cartUpdate listener below ignore this echo
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cm-auto-discount' });
          });
      })
      .catch(function (err) {
        console.warn('[cm-auto-discount] failed', err);
      })
      .finally(function () {
        inFlight = false;
      });
  }

  document.addEventListener('DOMContentLoaded', run, { once: true });
  subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
    if (event && event.source === 'cm-auto-discount') return;
    run();
  });
})();
